import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(email, password); // Perform login
      navigate("/merge"); // Redirect to the home page after successful login
    } catch (err) {
      setError(err.message); // Set error message for UI feedback
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gray-300 bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://trigononline.com/wp-content/uploads/2021/05/Index-Page.png')",
        objectFit: "cover"
      }}
    >
      <div className="bg-white shadow-xl rounded-lg p-10 max-w-lg w-full bg-opacity-90">
        <div className="text-center">
          <h2 className="mt-4 text-2xl font-bold text-gray-800">
          Welcome to Trigon's Dashboard
          </h2>
          <p className="text-gray-600 mt-2 text-sm font-semibold">
          Your powerful hub for Utility Insights & Efficiency!
          </p>
          <img
            src="./icons/trigon-icon.png"
            alt="Company Logo"
            className="mx-auto mt-4 w-48 h-auto"
          />
          {/* <p className="text-gray-600 mt-2 text-sm font-semibold">
          Your powerful hub for Utility Insights & Efficiency!
          </p> */}
        </div>

        <form onSubmit={handleLogin} className="mt-8 space-y-6">
          {error && <p className="text-red-500 text-sm">{error}</p>}

          <div className="relative">
            <label
              htmlFor="email"
              className="absolute -top-2.5 left-3 bg-white px-1 text-xs text-gray-500"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-3 text-gray-800 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter your email"
            />
          </div>

          <div className="relative">
            <label
              htmlFor="password"
              className="absolute -top-2.5 left-3 bg-white px-1 text-xs text-gray-500"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-3 text-gray-800 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter your password"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-blue-500 text-white text-sm font-medium shadow-md hover:bg-blue-600 focus:ring-2 focus:ring-blue-400"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
